import { Address } from './address';
import { User } from './user';

/**
 * Classe que representa uma Pessoa, com os dados em comum de qualquer pessoa, independente da entidade.
 */
export class Person {
    /** ID da entidade no Firebase  */
    uuid: string;

    /** Nome */
    name: string;
    /** Documento */
    document: string;
    /** Nascimento */
    birthday: any;
    /** Endereço */
    // address: Address;
    /** Telefone */
    phone: any;
    /** Usuário */
    user?: User;
    /** Data de Cadastro */
    date: any;
    /** Data de Atualização */
    update: any;

    address: Address;

    /**
     * Instanciar um
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<Person>) {
        Object.assign(this, init);
    }
}
